export default "__VITE_PUBLIC_ASSET__e8ad083d__"